import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardInfoDetails = styled(Card)(({theme, active}) => ({
  boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.16)', 
  marginTop: '0.5em',
  marginBottom: '0.5em',
  borderRadius: '0.6em',
  alignSelf: 'center',
  width: '90%',
  backgroundColor: active === 'true' ? theme.cardRoadStep.backgroundActiveColor : theme.cardRoadStep.backgroundColor,
  border: `1px solid ${active === 'true' ? theme.cardRoadStep.borderCardActive : theme.cardRoadStep.borderCard}`
}));

export const CardPathDetails = styled(Card)(({theme, active}) => ({
  borderRadius: '0.6em',
  alignSelf: 'center',
  width: '90%',
  backgroundColor: active === 'true' ? theme.cardRoadStep.backgroundActiveColor : theme.cardRoadStep.backgroundColor,
}));